export default __webpack_public_path__ + "static/media/testimonial3.0fdabd61.jpg";